import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

export interface ContactMessage {
    id: string;
    name: string | null;
    email: string;
    phoneNumber: string;
    message: string;
    screen: string;
    resolved: boolean;
    /** Name of the admin who resolved it, when known. */
    resolvedByName: string | null;
    createdAt: string;
}

/** Messages left through the public contact form (Fyes_UserMessages). */
@Injectable({ providedIn: 'root' })
export class AdminMessagesService extends HttpServiceBase {
    protected override baseUrl = '/admin/messages';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    /** Flags a message handled, or clears the flag. */
    public setResolved(id: string, resolved: boolean): Observable<any> {
        return this._http.put(`${this.baseUrl}/${id}/resolved`, { resolved })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
